import { ApisauceInstance } from 'apisauce';

const shareExportedReport = (
  exportData: ReportExportBody,
  api: ApisauceInstance,
) => api.post(`/v1/share/report`, exportData);

export default shareExportedReport;
